import EventClassService from 'src/modules/eventClass/eventClassService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/store';

const prefix = 'EVENTCLASS_VIEW';

const eventClassViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: eventClassViewActions.FIND_STARTED,
      });

      const record = await EventClassService.find(id);

      dispatch({
        type: eventClassViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: eventClassViewActions.FIND_ERROR,
      });

      getHistory().push('/event-class');
    }
  },
};

export default eventClassViewActions;
